export const NGT_PARTNER_ID = 85;

type SubscriptionId = 'fleksipakken' | 'strommepakken' | 'rikspakken';

export const subscriptionFeatureMap = new Map<SubscriptionId, { channels: number; streamingServices: string[] }>([
  ['fleksipakken', { channels: 22, streamingServices: ['HBO Max', 'TV 2 Play Basis med reklame'] }],
  ['strommepakken', { channels: 50, streamingServices: ['HBO Max', 'TV 2 Play Basis', 'Nordisk Film+', 'BBC Nordic+', 'SkyShowtime'] }],
  [
    'rikspakken',
    { channels: 61, streamingServices: ['HBO Max', 'TV 2 Play Basis', 'Nordisk Film+', 'BBC Nordic+', 'FilmFavoritter', 'SkyShowtime'] },
  ],
]);
